import crowdfund from "../../assets/CrowdFund-ScreenShoot.png";
import crowdfundRw from "../../assets/CrowdFund-ScreenShootRW.png";
import ikimina from "../../assets/Ikimina-ScreenShoot.png";
import ikiminaRw from "../../assets/Ikimina-ScreenShootRW.png";
import save from "../../assets/USave-ScreenShoot.png";
import saveRw from "../../assets/USave-ScreenShootRW.png";
// import invest from "../../assets/UInvest-ScreenShoot.png";
// import investRw from "../../assets/UInvest-ScreenShootRW.png";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { products, solutions } from "../../constants/landingConstants";
import { useEffect, useState } from "react";
import { useAppContext } from "../../context";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const images = [crowdfund, ikimina, save /*, invest*/];
const imagesRw = [crowdfundRw, ikiminaRw, saveRw /*, investRw*/];

export default function ProductsSection() {
  const { t } = useTranslation();
  const { language } = useAppContext();
  const [activeSolution, setActiveSolution] = useState("crowdfund");

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSolution(
        products[(products.indexOf(activeSolution) + 1) % products.length],
      );
    }, 5000); // Change every 8 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [activeSolution]);

  return (
    <div
      id="products"
      className="min-h-screen flex flex-col bg-white dark:bg-defaultBlack px-4 sm:px-6 lg:px-8 pt-20"
    >
      <div className="container mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-gray-900 dark:text-white">
          {t("productsPage.title")}
        </h1>

        {/* Mobile and Tablet Layout */}
        <div className="block lg:hidden space-y-12">
          {solutions.map((solution, index) => (
            <motion.div
              key={solution.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.7,
                delay: index * 0.15,
                ease: "easeOut",
              }}
              viewport={{ once: true }}
              className="flex flex-col items-start"
            >
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                {solution.title}
                {
                  index ===
                    (language === "en"
                      ? images.length - 1
                      : imagesRw.length - 1)
                  //   && (
                  // <span className="ml-1 px-2 py-1 text-xs font-semibold bg-defaultYellow text-defaultBlack rounded-full align-middle capitalize">
                  //   {t(`benefitsPage.launchingSoon`)}
                  // </span>)
                }
              </h3>
              <p className="text-gray-600 dark:text-white/70 mb-2">
                {t(`productsPage.${solution.description}`)}
              </p>
              {solution.title !== "U-Invest" && (
                <Link
                  to={`products/${solution.id}`}
                  className="text-blue-600/80 dark:text-blue-500/80 hover:text-blue-600 dark:hover:text-blue-500 group transition-all duration-300 hover:font-medium mb-4"
                >
                  {t("productsPage.learnMore")}
                  <ArrowRight
                    size={20}
                    className="inline-flex group-hover:scale-110 transition-all duration-300 group-hover:translate-x-1"
                  />
                </Link>
              )}
              <img
                src={language === "en" ? images[index] : imagesRw[index]}
                alt={solution.title}
                className="max-w-full h-auto object-contain"
              />
            </motion.div>
          ))}
        </div>

        {/* Desktop Layout */}
        <div className="hidden lg:flex lg:flex-row items-start gap-16">
          <div className="lg:w-1/2">
            <div className="space-y-6">
              {solutions.map((solution) => (
                <Solution
                  {...solution}
                  key={solution.id}
                  title={solution.title}
                  description={t(`productsPage.${solution.description}`)}
                  isActive={activeSolution === solution.id}
                  onClick={() => setActiveSolution(solution.id)}
                  badge={t(`benefitsPage.launchingSoon`)}
                />
              ))}
            </div>
          </div>
          <div className="lg:w-1/2 relative h-[600px] w-full overflow-hidden">
            {language === "en"
              ? images.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`${solutions[index].title} screenshot`}
                    className={`absolute transition-all duration-1000 w-full h-full object-contain ${
                      products.indexOf(activeSolution) === index
                        ? "opacity-100"
                        : "opacity-0"
                    }`}
                  />
                ))
              : imagesRw.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt="Financial Solutions"
                    className={`absolute transition-all duration-1000 w-full h-full object-contain ${
                      products.indexOf(activeSolution) === index
                        ? "opacity-100"
                        : "opacity-0"
                    }`}
                  />
                ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const Solution = ({
  title,
  description,
  isActive,
  onClick,
  badge,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <div className="relative">
      <div
        className={`flex items-start gap-4 ${isActive ? "mb-8" : "mb-4"}`}
        onClick={onClick}
      >
        <div
          className={`w-1 ${
            isActive
              ? "bg-defaultGreen/70 dark:bg-defaultGreen h-full absolute transition-all duration-500"
              : "bg-gray-200 dark:bg-white/10 h-6"
          }`}
        />
        <div className="pl-6">
          <div className="flex items-center gap-3 mb-2">
            <h3 className="cursor-pointer text-xl font-bold text-gray-900 dark:text-white">
              {title}
              {title === "U-Invest" && (
                <span className="ml-1 px-2 py-1 text-xs font-semibold bg-defaultYellow text-defaultBlack rounded-full align-middle capitalize">
                  {badge}
                </span>
              )}
            </h3>
          </div>
          <div className="animate-fadeIn md:hidden">
            <p className="text-gray-600 dark:text-white/70 mb-4">
              {description}
            </p>
          </div>
          <div className="hidden md:block">
            {isActive && (
              <div className="animate-fadeIn">
                <p className="text-gray-600 dark:text-white/70 mb-4">
                  {description}
                </p>
                {title !== "U-Invest" && (
                  <Link
                    to={`products/${rest.id}`}
                    className="text-blue-600/80 dark:text-blue-500/80 hover:text-blue-600 dark:hover:text-blue-500 group transition-all duration-300 hover:font-medium"
                  >
                    {t("productsPage.learnMore")}
                    <ArrowRight
                      size={20}
                      className="inline-flex group-hover:scale-110 transition-all duration-300 group-hover:translate-x-1"
                    />
                  </Link>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
